import { Component, OnInit } from "@angular/core";
import { ModelService } from '../../Services/model.service';
import { TranslateService } from '@ngx-translate/core';
import { WawiSettings } from "../../Model/User/WawiSettings";
import { CustomField } from "../../Model/User/CustomField";
import { custom } from 'devextreme/ui/dialog';
import { WawiListService } from "../../Services/wawiList.service";
import {WawiList, WawiListElement} from "../../Model/wawi/WawiList";
import { LoginService } from "../../Services/login.service";
import {firstValueFrom} from "rxjs";



@Component({
    selector: "wawiSettings",
    templateUrl: "wawiSettings.component.html",
    standalone: false
})
export class WawiSettingsComponent implements OnInit {
  veoListId: string = null;
  pages = [];
  fieldTypes = new Array<string>();
  wawiTabOptions = new Array<string>();
  lists: WawiList[];
  constructor(public modelService: ModelService, public translate: TranslateService, public wawiListService: WawiListService, public loginService: LoginService) {

    let supplierPidText = "";
    supplierPidText = this.translate.instant("Artikel");
    let customFieldsText = "";
    customFieldsText = this.translate.instant("Individuelle Felder");

    this.pages = [
      { id: 1, title: supplierPidText, template: "supplierPidTemplate" },
      { id: 2, title: customFieldsText, template: "customFieldsTextTemplate" }
    ];
    this.fieldTypes.push("String");
    this.fieldTypes.push("Number");
    this.fieldTypes.push("Boolean");
    this.fieldTypes.push("List");
    this.fieldTypes.push("Mapping");
    this.fieldTypes.push("Html");

    this.wawiTabOptions.push("Wawi");
    this.wawiTabOptions.push("Texte");

    wawiListService.getAllLists(this.modelService.loginService.currentCustomer.id).subscribe(result => {
      this.lists = result;
    });

  }

  public onRowRemoving(e) {
    let order = e.data.order;

    let txtYes = "";
    let txtNo = "";
    let txtMsg = "";
    let txtTitle = "";
    let myDialog: any;

    this.translate.get("Ja").subscribe((text: string) => {
      txtYes = text;
    });
    this.translate.get("Nein").subscribe((text: string) => {
      txtNo = text;
    });
    this.translate.get("Wollen Sie das Feld wirklich in allen Katalogen am Account löschen").subscribe((text: string) => {
      txtMsg = text;
      if (!txtMsg.endsWith("?")) {
        txtMsg = txtMsg + "?";
      }
    });
    this.translate.get("Wirklich löschen?").subscribe((text: string) => {
      txtTitle = text;
    });

    myDialog = custom({
      title: txtTitle,
      messageHtml: txtMsg,
      buttons: [
        {
          text: txtYes,
          onClick: (e) => { return false; }
        },
        {
          text: txtNo,
          onClick: (e) => { return true; }
        }
      ]
    });

    e.cancel = myDialog.show();
  }


  delete(event = null) {


    this.update(event);

  }


  ngOnInit(): void {
    if (this.modelService.loginService.currentUser == null) {
      this.modelService.router.navigate(["/"]);
      return;
    }
  }

  onSystemToolbarPreparing(e) {
    if (this.modelService.loginService.hasAddonGevis && !this.loginService.hasAddonVEO) {
     e.toolbarOptions.items.unshift({
       location: 'before',
       locateInMenu: 'auto',
       template: 'gevisButtonTemplate',
     });
    }

    if (this.modelService.loginService.hasAddonVEO) {
      e.toolbarOptions.items.unshift({
        location: 'before',
        locateInMenu: 'auto',
        template: 'veoButtonTemplate',
      });
    }

    e.toolbarOptions.items.unshift({
      location: 'before',
      locateInMenu: 'auto',
      template: 'newFieldButtonTemplate',
    });
  }

  addCustomField() {
    const customField = new CustomField();
    let order = 0;
    let index = 0;
    for (const field of this.model.customFields) {
      if (field.order > order) {
        order = field.order;
        index++;
      }
    }
    order += 1;
    customField.order = order;

    this.model.customFields.push(customField);
    customField.name = "CustomField" + order;
    this.updateWithRefresh();

  }

  isManager(): boolean {
    if (this.modelService.loginService.currentUser.currentClaim == "USER")
      return false;
    if (this.modelService.loginService.currentUser.currentClaim == "READONLY")
      return false;
    return true;
    }



   get model(): WawiSettings {
     return this.modelService.loginService.wawiSettings;
   }
  set model(value: WawiSettings) {
    this.modelService.loginService.wawiSettings = value;
   }


  update(e) {
    this.modelService.wawiSettingsService.update(this.model).subscribe(
      (result: number) => {
        this.model.id = result;

      });;
  }

  updateWithRefresh() {


    this.modelService.wawiSettingsService.update(this.model).subscribe(
      (result: number) => {
        this.modelService.wawiSettingsService.getWawiSettings(this.model.customerId).subscribe(
          (result: WawiSettings) => {
            this.model = result;
          });
      });;
  }




  get showPlaceHolders() {
    return this.modelService.loginService.showPlaceHolders;
  }

  generateGevisFields(){
    this.addFieldIfNotExist("Obergruppencode");
    this.addFieldIfNotExist("Gruppencode");
    this.addFieldIfNotExist("Untergruppencode");
    this.addFieldIfNotExist("Artikelkonditionsgruppencode");
    this.addFieldIfNotExist("Katalogartikelnummer 1");
    this.addFieldIfNotExist("Katalogartikelnummer 2");
    this.addFieldIfNotExist("Katalogartikelnummer 3");
    this.addFieldIfNotExist("Katalogartikelnummer 4");
    this.addFieldIfNotExist("Katalogartikelnummer 5");
    this.addFieldIfNotExist("WMV-Artikelnummer");
    this.updateWithRefresh();


  }

  async generateVEOFields() {
    this.addFieldIfNotExist("Obergruppencode");
    this.addFieldIfNotExist("Gruppencode");
    this.addFieldIfNotExist("Untergruppencode");
    this.addFieldIfNotExist("Artikelkonditionsgruppencode");
    this.addFieldIfNotExist("Katalogartikelnummer 1");
    this.addFieldIfNotExist("Katalogartikelnummer 2");
    this.addFieldIfNotExist("Katalogartikelnummer 3");
    this.addFieldIfNotExist("Katalogartikelnummer 4");
    this.addFieldIfNotExist("Katalogartikelnummer 5");
    this.addFieldIfNotExist("WMV-Artikelnummer");
    await this.ensureVEOWaviListExists();
    this.addFieldIfNotExist("Verkauf nur in VPE");
    this.addFieldIfNotExist("Einkauf nur in VPE");

    this.updateWithRefresh();
  }
  addFieldIfNotExist(newName: string) {
    if (this.model.customFields.findIndex(x => x.name == newName) < 0) {
      this.addField(newName);
    }
  }

  async addField(name: string) {
    const customField = new CustomField(  );
    let order = 0;
    let index = 0;
    for (const field of this.model.customFields) {
      if (field.order > order) {
        order = field.order;
        index++;
      }
    }
    order += 1;
    customField.order = order;

    if (name.startsWith("Verkauf") || name.startsWith("Einkauf")) {
      customField.fieldType = "List";
      customField.listId = this.veoListId;
    }
    this.model.customFields.push(customField);
    customField.name = name;

  }

  private async ensureVEOWaviListExists(): Promise<string> {
    if (this.veoListId) return this.veoListId;

    const idx = this.lists.findIndex(x => x.listName === "VEO-List");
    if (idx !== -1) {
      this.veoListId = this.lists[idx].id;
      return this.veoListId;
    }

    const newVEOWawiList = new WawiList(
      null, "VEO-List", null, "Optionen", false,
      [
        new WawiListElement(0, null, "Nein"),
        new WawiListElement(1, null, "Immer"),
        new WawiListElement(2, null, "Optional")
      ],
      true, null
    );

    const newVeoList = await firstValueFrom(
      this.wawiListService.create(newVEOWawiList, this.loginService.currentCustomer.id)
    );

    this.lists.push(newVeoList);
    this.veoListId = newVeoList.id;
    return this.veoListId;
  }
}


